import React, { useEffect, useState, useRef } from 'react';
import './MotionDesign.css';

const MotionDesign = React.forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={(el) => { sectionRef.current = el; if (ref) ref.current = el; }} className="motion-design">
      <div className="container">
        <div className={`motion-content ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">Motion Design & Edição</h2>
          <p className="section-subtitle">
            Criatividade em movimento. Projetos de vídeo e design para apresentações acadêmicas.
          </p>

          <div className="motion-grid">
            <div className="motion-card">
              <div className="motion-icon">🎬</div>
              <h3>Edição de Vídeo</h3>
              <p>Projetos profissionais para apresentações acadêmicas com transições suaves e efeitos visuais</p>
            </div>

            <div className="motion-card">
              <div className="motion-icon">✨</div>
              <h3>Motion Graphics</h3>
              <p>Animações e gráficos em movimento que dão vida às suas ideias</p>
            </div>

            <div className="motion-card">
              <div className="motion-icon">📸</div>
              <h3>Edição de Fotos</h3>
              <p>Tratamento e manipulação de imagens com técnicas profissionais</p>
            </div>

            <div className="motion-card">
              <div className="motion-icon">🎨</div>
              <h3>Design Visual</h3>
              <p>Criação de identidades visuais e materiais gráficos impactantes</p>
            </div>
          </div>

          <div className="featured-video">
            <h3>Vídeo em Destaque</h3>
            <div className="video-container">
              <iframe 
                width="100%" 
                height="500" 
                src="https://www.youtube.com/embed/j--rlm2Qv2o" 
                title="A Mulher Que Descobriu Como Retardar O Envelhecimento - Elizabeth Helen Blackburn" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="stories-section">
            <h3>Stories & Motion Graphics</h3>
            <div className="stories-grid">
              <div className="phone-3d">
                <div className="phone-shadow"></div>
                <div className="phone-device">
                  <div className="phone-notch-small"></div>
                  <video className="phone-video" autoPlay loop muted playsInline>
                    <source src="/MotionVideos/Storie1.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>

              <div className="phone-3d">
                <div className="phone-shadow"></div>
                <div className="phone-device">
                  <div className="phone-notch-small"></div>
                  <video className="phone-video" autoPlay loop muted playsInline>
                    <source src="/MotionVideos/Storie2.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>

              <div className="phone-3d">
                <div className="phone-shadow"></div>
                <div className="phone-device">
                  <div className="phone-notch-small"></div>
                  <video className="phone-video" autoPlay loop muted playsInline>
                    <source src="/MotionVideos/Storie3.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>

              <div className="phone-3d">
                <div className="phone-shadow"></div>
                <div className="phone-device">
                  <div className="phone-notch-small"></div>
                  <video className="phone-video" autoPlay loop muted playsInline>
                    <source src="/MotionVideos/Storie4.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default MotionDesign;
